import ko from '@tko/build.knockout';
import templateMarkup from 'raw-loader!./kpipanel-widget.html';
import _ from 'lodash';
import ClickThruService from "../../../services/clickthru.service";
import $ from "jquery";
import DataProvider from "../../../app/data-framework/data-provider";

let KPI = 'KPI';

function KpiCellWidget(params) {
    var self = this;

    self.observableOptions = params.observableOptions;
    self.observableData = params.observableData;
    self.panelTemplate = params.panelTemplate;
    self.widgetSignals = params.widgetSignals;
    self.dataProvider = DataProvider.getInstance();
    self.subscriptions = [];

    self.loadMode = true;

    self.value = ko.observable('0');
    self.abbreviatedValue = ko.observable('0');
    self.changeindicator = ko.observable('--');
    self.kpicellchangeindicatorstyle = ko.observable('kpicellchangeindicatorstyle text-gray');
    self.changevalue = ko.observable('0');
    self.kpicellchangevaluestyle = ko.observable('kpicellchangevaluestyle text-gray');

    self.clickCallback = function () {
        if (self.changevalue() === '0') return;

        var options = params.observableOptions();
        // var observableParams = ko.unwrap(_.get(params, 'observableParamsList[0]'));
        var paramsTemp = ko.unwrap(params.viewLevelOptions);

        var metadata = _.get(ko.unwrap(self.observableData), 'metadata', null);
        var kpiCol = getKpiColumnKey(metadata, options);

        let start = paramsTemp.inpStartDate.replace(/\//g, '-');
        let end = paramsTemp.inpEndDate.replace(/\//g, '-');
        let date = undefined;

        // currently we do not support group bys on KPIs so groupColumn and filterval are empty
        ClickThruService.clickThru(KPI,
            kpiCol.columnKey, '', kpiCol.categoryKey,
            options.whereConditionObj,
            date, start, end,
            '', false,
            self.allFilterColumns);

    };

    self.loadData = function () {
        if (!params.viewLevelOptions()) {
            return;
        }

        var options = params.observableOptions();
        var observableParams = ko.unwrap(_.get(params, 'observableParamsList[0]'));
        var paramsTemp = ko.unwrap(params.viewLevelOptions);

        var metadata = _.get(ko.unwrap(self.observableData), 'metadata', null);
        self.allFilterColumns = $.extend(true, [], metadata.FilterCols);
        var kpiCol = getKpiColumnKey(metadata, options);

        if (_.isEmpty(metadata)) {
            return null; // there's nothing to do until we get the metadata
        }
        if (_.isEmpty(kpiCol)) {
            if (self.loadMode) {
                self.dispatchDataLoaded();
            }
            return;
        }

        if (_.isFunction(_.get(self, 'widgetSignals().dataRequested.dispatch'))) {
            self.widgetSignals().dataRequested.dispatch();
        }

        paramsTemp.aggregatefact = getAggregeFact(kpiCol);

        paramsTemp.groupby = '';
        paramsTemp.WhereCondition = JSON.stringify(options.whereConditionObj) || '1=1';
        paramsTemp.WhereConditionConjunction = options.whereConditionConjunction || 'AND';
        paramsTemp.dataset = '';
        paramsTemp.timegrain = '';
        paramsTemp.tag = '';
        paramsTemp.sortColumn = '';
        paramsTemp.hoursPerDay = options.selectedHoursPerDay;
        paramsTemp.daysPerWeek = options.selectedDaysPerWeek;

        observableParams.paramsJson = ko.toJSON(paramsTemp);
        observableParams.panelId = options.id;

        if (ko.isObservable(_.get(params, 'observableParamsList[0]'))) {
            params.observableParamsList[0](observableParams);
        }

        self.loadMode = false;
    };

    if (params.viewLevelOptions) {
        self.subscriptions.push(params.viewLevelOptions.subscribe(function () {
            if (self.loadMode) {
                return;
            }

            self.loadData();
        }));
    }

    self.subscriptions.push(params.observableData.subscribe(function () {
        self.DataUpdated();
    }));

    self.subscriptions.push(params.observableOptions.subscribe(function () {
        self.OptionsUpdated();
    }));

    self.loadData();
}

KpiCellWidget.prototype.RefreshData = function () {
    var self = this;
    var data = self.observableData();

    if (_.isEmpty(data)) {
        return;
    }

    self.value(_.get(data, 'kpi.value', '0'));
    self.abbreviatedValue(_.get(data, 'kpi.abbreviatedValue', '0'));

    if (!_.isEmpty(_.get(data, 'kpi.change'))) {
        self.changeindicator(_.get(data, 'kpi.change.changeindicator'));
        self.kpicellchangeindicatorstyle(_.get(data, 'kpi.change.changeindicatorstyle'));
        self.kpicellchangevaluestyle(_.get(data, 'kpi.change.changeindicatorstyle'));
        self.changevalue(_.get(data, 'kpi.change.value'));
    }
};

KpiCellWidget.prototype.DataUpdated = function () {
    var self = this;

    if (self.loadMode) {
        self.loadData();
    }

    self.RefreshData();
    self.dispatchDataLoaded();

};

KpiCellWidget.prototype.dispatchDataLoaded = function() {
    // Signal dataLoaded when the data request has been fulfilled and the data is updated.
    if (_.isFunction(_.get(this.widgetSignals(), 'dataLoaded.dispatch')) && !_.isEmpty(this.observableData().metadata)) {
        this.widgetSignals().dataLoaded.dispatch();
    }
};

KpiCellWidget.prototype.OptionsUpdated = function () {
    var self = this;

    self.loadMode = true;
    self.loadData();
};

KpiCellWidget.prototype.dispose = function () {
    var self = this;

    self.subscriptions.forEach(function (sub) {
        sub.dispose();
    });
};

function getKpiColumnKey(metadata, options) {
    var kpiColumn = _.first(options.selectedMetricColumnNames) || _.first(options.selectedKPIColumnNames);

    if (_.isEmpty(kpiColumn)) {
        return;
    }

    return  _.find(metadata.Table, ['columnKey', kpiColumn]);
}

function getAggregeFact(kpiMetric) {
    var aggregateFunction = _.get(kpiMetric, 'aggregateFunction', 'sum');

    return aggregateFunction + '(' + _.get(kpiMetric, 'columnKey', '') + ')';
}

export default {
    viewModel: {
        createViewModel: function(params, componentInfo) {
            return new KpiCellWidget(params);
        }
    },
    template: templateMarkup
};
